export const stickerTypes = Object.freeze({
  BOX: 'Box',
  PERSONAL: 'Personal'
});

export const reusePolicies = Object.freeze({
  ONE_TIME: 'One time',
  REGULAR: 'Regular'
});
